// Hand-drawn blue-ink line illustrations — Valle-specific vocabulary
// Paloma (dove), ocote pine, sailboat, waves — for the masthead and page accents

export const InkFlourish = ({ className = "", stroke = "#1F3A6E" }) => (
  <svg viewBox="0 0 180 40" fill="none" className={className} aria-hidden="true">
    <path d="M4 22 C 30 6, 60 6, 90 22 S 150 38, 176 22" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" fill="none"/>
    <path d="M4 22 L 8 22 M 176 22 L 172 22" stroke={stroke} strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

// Paloma — dove/bird, nod to Valle's parapente scene above La Peña
export const InkPaloma = ({ className = "", stroke = "#1F3A6E" }) => (
  <svg viewBox="0 0 140 90" fill="none" className={className} aria-hidden="true">
    {/* body */}
    <path d="M42 52 C 52 44, 68 42, 86 46 C 96 48, 104 52, 108 58 C 112 66, 106 72, 96 72 L 60 72 C 48 72, 40 66, 42 52 Z" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" fill="none"/>
    {/* wing arch */}
    <path d="M52 52 C 60 30, 82 22, 108 30 C 96 40, 84 46, 74 50" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" fill="none"/>
    {/* wing feathers */}
    <path d="M64 38 L 72 46 M 76 32 L 82 42 M 88 30 L 92 40" stroke={stroke} strokeWidth="1.2" strokeLinecap="round"/>
    {/* head + beak */}
    <circle cx="106" cy="52" r="6" stroke={stroke} strokeWidth="1.5" fill="none"/>
    <path d="M112 52 L 122 50" stroke={stroke} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="108" cy="51" r="0.8" fill={stroke}/>
    {/* tail */}
    <path d="M42 60 L 28 58 M 42 64 L 26 66 M 44 68 L 30 72" stroke={stroke} strokeWidth="1.3" strokeLinecap="round"/>
    {/* motion below */}
    <path d="M20 82 Q 40 78, 60 82 T 100 82 T 132 82" stroke={stroke} strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
  </svg>
);

// Ocote — Mexican long-needle pine, characteristic of Valle bosque
export const InkOcote = ({ className = "", stroke = "#1F3A6E" }) => (
  <svg viewBox="0 0 80 140" fill="none" className={className} aria-hidden="true">
    {/* trunk */}
    <path d="M40 128 L 40 30" stroke={stroke} strokeWidth="1.6" strokeLinecap="round"/>
    {/* branches on left */}
    <path d="M40 44 L 22 52 M 40 56 L 18 66 M 40 68 L 20 80 M 40 80 L 22 94 M 40 92 L 26 106 M 40 104 L 30 118" stroke={stroke} strokeWidth="1.3" strokeLinecap="round"/>
    {/* branches on right */}
    <path d="M40 38 L 60 46 M 40 52 L 62 62 M 40 64 L 62 76 M 40 76 L 60 90 M 40 88 L 56 102 M 40 100 L 52 114" stroke={stroke} strokeWidth="1.3" strokeLinecap="round"/>
    {/* needle clusters (small dashes at branch tips) */}
    <g stroke={stroke} strokeWidth="0.9" strokeLinecap="round">
      <path d="M20 50 L 18 46 M 22 54 L 20 58"/>
      <path d="M16 64 L 14 60 M 18 68 L 16 72"/>
      <path d="M18 78 L 16 74 M 20 82 L 18 86"/>
      <path d="M20 92 L 18 88 M 22 96 L 20 100"/>
      <path d="M24 104 L 22 100 M 26 108 L 24 112"/>
      <path d="M62 44 L 64 40 M 64 48 L 66 52"/>
      <path d="M64 60 L 66 56 M 66 64 L 68 68"/>
      <path d="M64 74 L 66 70 M 66 78 L 68 82"/>
      <path d="M62 88 L 64 84 M 64 92 L 66 96"/>
      <path d="M58 100 L 60 96 M 60 104 L 62 108"/>
    </g>
    {/* apex tuft */}
    <path d="M40 30 C 36 24, 42 20, 40 12 C 44 18, 46 24, 44 30" stroke={stroke} strokeWidth="1.3" strokeLinejoin="round" fill="none"/>
    {/* ground line */}
    <path d="M14 132 L 66 132" stroke={stroke} strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
  </svg>
);

// Sailboat with proper hull silhouette (for Valle lake/vela references)
export const InkSailboat = ({ className = "", stroke = "#1F3A6E" }) => (
  <svg viewBox="0 0 140 130" fill="none" className={className} aria-hidden="true">
    {/* mast */}
    <path d="M70 8 L 70 90" stroke={stroke} strokeWidth="1.6" strokeLinecap="round"/>
    {/* main sail (larger, back) */}
    <path d="M70 12 L 108 88 L 70 88 Z" stroke={stroke} strokeWidth="1.6" strokeLinejoin="round" fill="none"/>
    {/* jib (front sail, curved) */}
    <path d="M70 20 C 58 40, 46 62, 40 88 L 70 88" stroke={stroke} strokeWidth="1.6" strokeLinejoin="round" fill="none"/>
    {/* sail creases */}
    <path d="M78 34 C 82 40, 84 48, 84 54" stroke={stroke} strokeWidth="0.9" opacity="0.6" fill="none"/>
    <path d="M62 40 C 58 52, 54 68, 52 82" stroke={stroke} strokeWidth="0.9" opacity="0.6" fill="none"/>
    {/* hull — curved with proper stern/bow */}
    <path d="M18 90 L 22 96 C 30 108, 44 112, 70 112 C 96 112, 110 108, 118 96 L 122 90 Z" stroke={stroke} strokeWidth="1.6" strokeLinejoin="round" fill="none"/>
    {/* hull waterline */}
    <path d="M22 96 L 118 96" stroke={stroke} strokeWidth="1" opacity="0.5"/>
    {/* water below */}
    <path d="M4 122 Q 20 116, 36 122 T 68 122 T 100 122 T 136 122" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" opacity="0.55"/>
    <path d="M14 128 Q 30 124, 46 128 T 78 128 T 110 128" stroke={stroke} strokeWidth="1" strokeLinecap="round" opacity="0.35"/>
  </svg>
);

// Legacy helpers kept for existing pages
export const InkLeaf = ({ className = "", stroke = "#1F3A6E" }) => (
  <svg viewBox="0 0 120 60" fill="none" className={className} aria-hidden="true">
    <path d="M4 42 C 30 12, 70 12, 116 40" stroke={stroke} strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M14 38 C 22 32, 30 32, 36 38" stroke={stroke} strokeWidth="1.4" strokeLinecap="round"/>
    <path d="M32 32 C 42 24, 52 24, 60 32" stroke={stroke} strokeWidth="1.4" strokeLinecap="round"/>
    <path d="M52 26 C 64 20, 76 20, 84 26" stroke={stroke} strokeWidth="1.4" strokeLinecap="round"/>
    <path d="M76 24 C 88 20, 98 22, 104 28" stroke={stroke} strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

export const InkWineGlass = ({ className = "", stroke = "#1F3A6E" }) => (
  <svg viewBox="0 0 60 100" fill="none" className={className} aria-hidden="true">
    <path d="M14 8 C 14 40, 22 52, 30 52 C 38 52, 46 40, 46 8" stroke={stroke} strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M30 52 L 30 82" stroke={stroke} strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M18 82 L 42 82" stroke={stroke} strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M18 20 C 24 24, 36 24, 42 20" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" strokeDasharray="1 3"/>
  </svg>
);

export const InkWaves = ({ className = "", stroke = "#1F3A6E" }) => (
  <svg viewBox="0 0 200 30" fill="none" className={className} aria-hidden="true">
    <path d="M0 15 Q 20 4, 40 15 T 80 15 T 120 15 T 160 15 T 200 15" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" fill="none"/>
    <path d="M0 24 Q 20 14, 40 24 T 80 24 T 120 24 T 160 24 T 200 24" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" fill="none" opacity="0.55"/>
  </svg>
);

export const InkLemon = ({ className = "", stroke = "#1F3A6E" }) => (
  <svg viewBox="0 0 100 100" fill="none" className={className} aria-hidden="true">
    <ellipse cx="52" cy="60" rx="30" ry="22" transform="rotate(-18 52 60)" stroke={stroke} strokeWidth="1.6"/>
    <path d="M28 44 L 20 36" stroke={stroke} strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M18 36 C 10 30, 6 24, 8 16 C 18 12, 26 20, 30 30" stroke={stroke} strokeWidth="1.6" strokeLinejoin="round" fill="none"/>
    <path d="M76 78 L 84 88" stroke={stroke} strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
);

export const INK_OPTIONS = [
  { value: "", label: "— Ninguno —" },
  { value: "paloma", label: "Paloma" },
  { value: "ocote", label: "Ocote" },
  { value: "velero", label: "Velero" },
  { value: "flourish", label: "Flourish" },
  { value: "waves", label: "Olas" },
  { value: "wineglass", label: "Copa" },
  { value: "leaf", label: "Rama" },
];

export const InkByName = ({ name, className = "", stroke = "#1F3A6E" }) => {
  switch (name) {
    case "paloma": return <InkPaloma className={className} stroke={stroke} />;
    case "ocote": return <InkOcote className={className} stroke={stroke} />;
    case "velero": return <InkSailboat className={className} stroke={stroke} />;
    case "flourish": return <InkFlourish className={className} stroke={stroke} />;
    case "waves": return <InkWaves className={className} stroke={stroke} />;
    case "wineglass": return <InkWineGlass className={className} stroke={stroke} />;
    case "leaf": return <InkLeaf className={className} stroke={stroke} />;
    default: return null;
  }
};
